import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { bonusAvailable as orgConfig } from 'org/configs/modules.config';
import { BONUS_AVAILABLE_GET_SUCCESS, BONUS_AVAILABLE_GET_FAILURE } from '../actions/types';

const defaultConfig = {
  defaults: {
    api: {
      params: {},
      options: {
        success: BONUS_AVAILABLE_GET_SUCCESS,
        failure: BONUS_AVAILABLE_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
